module.exports = __webpack_public_path__ + "img/741.9a3df32a.jpg";